// Module
var code = "<div class=\"widget-content relative\"> <wt-line-chart id=\"{{vm.id}}\" chart-data=\"vm.data\" hovered=\"vm.hovered\" options=\"vm.options\" series=\"vm.series\" zoom-control=\"vm.item\"> </wt-line-chart> </div>";
// Exports
module.exports = code;